import makeApiCall from "../master/axiosIndex";

const dispatchApis = {
  submitDispatch: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/submitDispatch",
      method: "post",
      data: data,
    }),
  fetchAllDispatches: (): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllDispatches",
      method: "get",
    }),
  fetchDispatch: (id: string): Promise<any> =>
    makeApiCall<any>({
      url: `/dispatch/fetchDispatch?dispatchNumber=${id}`,
      method: "get",
    }),
  fetchAllDispatchesByInvoiceLineNo: (invoiceLineNo: any): Promise<any> =>
    makeApiCall<any>({
      url: `/dispatch/fetchAllDispatchesByInvoiceLineNo?invoiceLineNo=${invoiceLineNo}`,
      method: "get",
    }),
  fetchAllUserDeliveredDispatches: (): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllUserDeliveredDispatches",
      method: "get",
    }),
  fetchAllDispatchesWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllDispatchesWithPagination",
      method: "get",
      params,
    }),
    fetchAllSupplierInvoicesForDispatchWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
        url: "/billing/fetchAllSupplierInvoicesForDispatchWithPagination",
        method: "get",
        params,
    })
};

export default dispatchApis;
